export default __webpack_public_path__ + "static/media/trqk_logo_639w_black.7b13c5ca.svg";